<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.invoice_title" placeholder="请输入发票抬头" style="width: 220px;" clearable/>

      <el-select class="filter-item" v-model="listQuery.status" placeholder="请选择状态" style="width: 140px" clearable>
        <el-option label="未开票" :value="0"></el-option>
        <el-option label="已开票" :value="1"></el-option>
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.school ? scope.row.school.school_name : "" }}
        </template>
      </el-table-column>

      <el-table-column label="站长" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction:column;align-items:center;text-align:center;">
            <img :src="scope.row.stationmaster.avatar" style="width: 26px;height:26px;border-radius:4px;margin-right:4px;">
            <span>{{ scope.row.stationmaster.name }}</span>
            <span>{{ scope.row.stationmaster.phone }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="发票抬头" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.invoice_title }}
        </template>
      </el-table-column>

      <el-table-column label="纳税人识别号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.taxpayer_identification_number }}
        </template>
      </el-table-column>

      <el-table-column label="发票类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.invoice_type === 1" type="primary">电子发票</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="发票内容" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.invoice_content }}
        </template>
      </el-table-column>

      <el-table-column label="发票金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.invoice_amount }}
        </template>
      </el-table-column>

      <el-table-column label="注册地址" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.register_address }}
        </template>
      </el-table-column>

      <el-table-column label="注册电话" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.register_phone }}
        </template>
      </el-table-column>

      <el-table-column label="开户银行" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.opening_bank }}
        </template>
      </el-table-column>

      <el-table-column label="银行账户" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.bank_account }}
        </template>
      </el-table-column>

      <el-table-column label="接收电子邮件" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.receive_email }}
        </template>
      </el-table-column>

      <el-table-column label="接收手机号码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.receive_phone }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="danger">未开票</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="success">已开票</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="handleDownloadInvoice(scope.row.invoice_image)" v-if="scope.row.invoice_image">下载发票</el-button>

          <el-button type="warning" size="mini" @click="handleUpdateInvoiceImage(scope.row)" v-if="!scope.row.invoice_image">上传发票</el-button>
          <el-button type="warning" size="mini" @click="handleUpdateInvoiceImage(scope.row)" v-else>重新上传发票</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 上传发票 -->
    <el-dialog title="上传发票" :visible.sync="dialogVisibleUpdateInvoiceImage" width="60%" :close-on-click-modal="false">
      <el-form ref="updateInvoiceImageForm" :rules="updateInvoiceImageRules" :model="updateInvoiceImageForm" label-width="150px">
        <el-form-item label="发票凭证" prop="invoice_image">
          <upload-one v-model="updateInvoiceImageForm.invoice_image"></upload-one>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleUpdateInvoiceImage = false">取消</el-button>
        <el-button type="primary" @click="saveDataUpdateInvoiceImage" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 上传发票 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          invoice_title: "",
          status: "",
        },
        // 上传发票
        dialogVisibleUpdateInvoiceImage: false,
        btnLoading: false,
        updateInvoiceImageForm: {
          id: "",
          invoice_image: "",
        },
        updateInvoiceImageRules: {
          invoice_image: [{ required: true, message: "发票凭证不能为空", trigger: "change" }],
        },
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/stationmasterInvoice/list",
          method: "get",
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      // 下载发票
      handleDownloadInvoice(invoiceImage) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const image = new Image();
        image.crossOrigin = "Anonymous";
        image.src = invoiceImage;
        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const imageUrl = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = imageUrl;
          link.download = "downloaded-image.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        };
      },
      // 上传发票
      handleUpdateInvoiceImage(row) {
        this.updateInvoiceImageForm = {
          id: row.id,
          invoice_image: "",
        };
        this.dialogVisibleUpdateInvoiceImage = true;
        this.$nextTick(() => {
          this.$refs["updateInvoiceImageForm"].clearValidate() //清除校验结果
        })
      },
      saveDataUpdateInvoiceImage() {
        this.$refs["updateInvoiceImageForm"].validate((valid) => {
          if (valid) {
            this.btnLoading = true;
            request({
              url: "/api/backend/stationmasterInvoice/updateInvoiceImage",
              method: "post",
              data: this.updateInvoiceImageForm,
            }).then(() => {
              this.dialogVisibleUpdateInvoiceImage = false;
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).finally(() => {
              this.btnLoading = false;
            });
          }
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
